import { PROMPT_INSTRUCTION_TYPE } from 'src/data/generation';

export const INFINITY_EXTENSION_MODE = {
  promptGeneration: 'promptGeneration',
  variationsGeneration: 'variationsGeneration',
};

export const CANVAS_PROJECT_FORM_EVENT = {
  backClicked: 'backClicked',
};

export const SUGGEST_STRUCTURE_INSTRUCTION_TYPES = [
  PROMPT_INSTRUCTION_TYPE.vocabulary,
  PROMPT_INSTRUCTION_TYPE.format,
  PROMPT_INSTRUCTION_TYPE.formula,
];

export const REWRITE_STRUCTURE_INSTRUCTION_TYPES = [
  PROMPT_INSTRUCTION_TYPE.vocabulary,
  PROMPT_INSTRUCTION_TYPE.format,
];

export const SINGLE_PROMPT_ID = 'single_prompt';

export const ADVANCED_SETTINGS_VIEW_TYPE = {
  settings: 'settings',
  toneOfVoiceList: 'toneOfVoiceList',
  imageStyleList: 'imageStyleList',
  talkingPointsList: 'talkingPointsList',
} as const;

export const ADVANCED_SETTINGS_VIEW_PROPS = {
  settings: {
    title: 'Advanced',
    showBackButton: false,
    view: ADVANCED_SETTINGS_VIEW_TYPE.settings,
  },
  toneOfVoiceList: {
    title: 'Tone of Voice',
    showBackButton: true,
    view: ADVANCED_SETTINGS_VIEW_TYPE.toneOfVoiceList,
  },
  imageStyleList: {
    title: 'Image Style',
    showBackButton: true,
    view: ADVANCED_SETTINGS_VIEW_TYPE.imageStyleList,
  },
  talkingPointsList: {
    title: 'A/B tested talking Points',
    showBackButton: true,
    view: ADVANCED_SETTINGS_VIEW_TYPE.talkingPointsList,
  },
} as const;
